import SpriteSymbol from "../../../../dev-d21-front/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../dev-d21-front/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "home-icon",
  "use": "home-icon-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 18 18\" id=\"home-icon\"><path fill=\"currentColor\" d=\"M17 16V8.361a2 2 0 0 0-.75-1.561l-6-4.8a2 2 0 0 0-2.5 0l-6 4.8A2 2 0 0 0 1 8.36V16a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1H16a1 1 0 0 0 1-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol